// menuFilter.js

function filterItem(item, context) {
  if (item.feature && !context.features[item.feature]) {
    return false;
  }

  if (item.companies && !item.companies.includes(context.company)) {
    return false;
  }

  if (item.desktopOnly && context.isMobile) {
    return false;
  }

  return true;
}

export function filterMenu(items, context) {
  return items
    .filter((item) => filterItem(item, context))
    .map((item) => ({
      ...item,
      submenu: item.submenu ? filterMenu(item.submenu, context) : undefined,
    }))
    .filter((item) => {
      if (!item.submenu) return true;
      return item.submenu.length > 0;
    });
}
